import type { UploadedWorkspaceVideo } from './types'

interface PlaybackVersionOptions {
  audioMixDeliveryVideo: UploadedWorkspaceVideo | null
  uploadedFinalVideo: UploadedWorkspaceVideo | null
}

export function getCurrentPlaybackLabel(options: PlaybackVersionOptions) {
  if (options.audioMixDeliveryVideo?.url) return '声音交付版'
  if (options.uploadedFinalVideo?.url) return '人工终版'
  return '系统成片'
}

export function getCurrentPlaybackStatusChip(options: PlaybackVersionOptions) {
  if (options.audioMixDeliveryVideo?.url) return '优先播放声音交付版'
  if (options.uploadedFinalVideo?.url) return '优先播放人工终版'
  return '优先播放系统成片'
}
